import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FileText, Video, Image, Book, Music, Code, Map, User } from 'lucide-react';
import { generateClient } from 'aws-amplify/api';
import { listBlogPosts } from '../graphql/queries';
import './BlogList.css';
import { blogPosts } from '../data/blogposts';

const iconMap = {
  'file-text': FileText,
  'video': Video,
  'image': Image,
  'book': Book,
  'music': Music,
  'code': Code,
  'map': Map,
  'user': User
};

const client = generateClient({ authMode: 'apiKey' });

const BlogList = () => {
  const [posts, setPosts] = useState([]);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchPosts();
  }, []);

  async function fetchPosts() {
    try {
      const blogData = await client.graphql({
        query: listBlogPosts
      });

      const fetchedPosts = blogData.data.listBlogPosts.items;

      // If we have posts from the database, use those
      if (fetchedPosts && fetchedPosts.length > 0) {
        setPosts(fetchedPosts);
      } else {
        // Otherwise use our local data
        console.log('Using local blog post data instead of database');
        setPosts(blogPosts);
      }
    } catch (err) {
      console.error('Error fetching blog posts:', err);
      console.log('Using local blog post data instead of database');
      setPosts(blogPosts);
    } finally {
      setLoading(false);
    }
  }

  if (loading) {
    return <div className="blog-list__loading">Loading blog posts...</div>;
  }

  if (error && posts.length === 0) {
    return <div className="blog-list__error">{error}</div>;
  }

  return (
    <div className="blog-list">
      <div className="blog-list__header">
        <h1 className="blog-list__title">ChoiceRealms Blog</h1>
        <p className="blog-list__subtitle">Latest news and updates about our adventure platform</p>
      </div>

      <div className="blog-list__grid">
        {posts.map((post) => {
          const Icon = iconMap[post.iconName] || FileText;
          return (
            <div key={post.id} className="blog-card">
              <div className="blog-card__content">
                <div className="blog-card__meta">
                  <Icon className="blog-card__icon" />
                  <span className="blog-card__date">
                    {new Date(post.publishDate).toLocaleDateString('en-US', {
                      year: 'numeric',
                      month: 'long',
                      day: 'numeric'
                    })}
                  </span>
                </div>
                <h2 className="blog-card__title">{post.title}</h2>
                <p className="blog-card__excerpt">{post.excerpt}</p>
                <div className="blog-card__footer">
                  <span className="blog-card__author">By {post.author}</span>
                  <Link to={`/blog/${post.id}`} className="blog-card__link">
                    Read More →
                  </Link>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default BlogList;